import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import AllergyCategoriesPage from "./allergy-categories-page";
import AllergyCategoryCreatePage from "./allergy-category-create-page";
import AllergyCategoryEditPage from "./allergy-category-edit-page";
 

export default (
  <Route path="allergy-categories">
    <Route
      index
      element={
        <Protected
          path="/admin/allergy-categories"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <AllergyCategoriesPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/allergy-categories/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <AllergyCategoryCreatePage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/allergy-categories/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <AllergyCategoryEditPage />
        </Protected>
      }
    />  
  </Route>
);
